import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ButtonDirective } from '@coreui/angular';
import { IconDirective } from '@coreui/icons-angular';
import {
  cilCopy,
  cilCloudDownload,
  cilArrowLeft,
  cilShareAlt,
} from '@coreui/icons';

@Component({
  selector: 'app-credentials-two',
  standalone: true,
  imports: [CommonModule, ButtonDirective, IconDirective],
  templateUrl: './credentials-two.component.html',
  styleUrl: './credentials-two.component.scss',
})
export class CredentialsTwoComponent implements OnInit, OnChanges {
  isDarkTheme = false;
  imageLoaded = false;

  icons = {
    cilCopy,
    cilCloudDownload,
    cilArrowLeft,
    cilShareAlt,
  };

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const raw = localStorage.getItem('sharewave-frontend-theme-default');
    let theme: string | null = raw;
    if (raw) {
      try {
        theme = JSON.parse(raw);
      } catch {
        theme = raw;
      }
    }

    this.isDarkTheme = theme === 'dark';
    console.log('Theme:', theme);
    console.log('Dark Theme:', this.isDarkTheme);
  }

  @Input() agradecimiento!: string;
  @Input() shareText!: string;

  safeAgradecimiento!: SafeHtml;
  safeShareText!: SafeHtml;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['agradecimiento']) {
      this.safeAgradecimiento = this.sanitizer.bypassSecurityTrustHtml(
        this.agradecimiento || '',
      );
    }
    if (changes['shareText']) {
      this.safeShareText = this.sanitizer.bypassSecurityTrustHtml(
        this.shareText || '',
      );
    }
    if (changes['imageUrl']) {
      const prev = changes['imageUrl'].previousValue;
      const curr = changes['imageUrl'].currentValue;
      const prevBase = prev ? String(prev).split('?')[0] : '';
      const currBase = curr ? String(curr).split('?')[0] : '';

      if (!prevBase || prevBase !== currBase) {
        this.imageLoaded = false;
      }
    }
  }

  onImageLoad(): void {
    this.imageLoaded = true;
  }

  onImageError(): void {
    this.imageLoaded = true;
  }

  @Input() buttonColors!: {
    copy: string;
    download: string;
    share: string;
    back: string;
  };
  @Input() textColorInstructivo: string = '#000000';
  @Input() backgroundColor: string = '#ffffff';
  @Input() imageUrl: string | null = null;
  @Input() loading = false;
  @Input() previewMode = false;
  @Input() downloading = false;

  @Output() copy = new EventEmitter<void>();
  @Output() download = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();
  @Output() share = new EventEmitter<void>();
}
